import StaticContentsContainer from '../../components/StaticContentsContainer';
import { cEl } from '../../../../../util';
import { animate } from 'motion';
import leftArrow from '../../../../../assets/images/left-arrow.svg';
import rightArrow from '../../../../../assets/images/right-arrow.svg';
import GuideSlide from './GuideSlide';
import SelectionCriteriaSlide from './SelectionCriteriaSlide';
import ScenarioSlide from './ScenarioSlide';
import EnvironmentSlide from './EnvironmentSlide';

function SelfDiagnosticTest() {
    const container = StaticContentsContainer();
    container.classList.add('carousel-container');

    const carousel = cEl('div');
    carousel.classList.add('carousel');
    carousel.append(GuideSlide(), SelectionCriteriaSlide(), ScenarioSlide(), EnvironmentSlide());

    const controls = cEl('div');
    controls.classList.add('controls');

    const prevButton = cEl('button');
    prevButton.classList.add('button', 'prev-button');
    const prevImg = cEl('img');
    prevImg.src = leftArrow;
    prevImg.alt = 'left arrow';
    prevButton.appendChild(prevImg);

    const nextButton = cEl('button');
    nextButton.classList.add('button', 'next-button');
    const nextImg = cEl('img');
    nextImg.src = rightArrow;
    nextImg.alt = 'right arrow';
    nextButton.appendChild(nextImg);

    controls.append(prevButton, nextButton);

    container.append(carousel, controls);

    const slideLength = 4;
    let currentIndex = 0;

    const updateButtons = () => {
        prevButton.disabled = currentIndex === 0;
        nextButton.disabled = currentIndex === slideLength - 1;
    };

    const moveCarousel = index => {
        const offset = -index * 100; // Calculate offset in percentage
        animate(
            carousel,
            {
                translateX: `${offset}%`,
            },
            {
                duration: 0.6,
                easing: 'ease-in-out',
            },
        );
        updateButtons();
    };

    prevButton.addEventListener('click', () => {
        if (currentIndex > 0) {
            currentIndex--;
            moveCarousel(currentIndex);
        }
    });

    nextButton.addEventListener('click', () => {
        if (currentIndex < slideLength - 1) {
            currentIndex++;
            moveCarousel(currentIndex);
        }
    });

    updateButtons();

    return container;
}

export default SelfDiagnosticTest;
